/* UI-DESIGN: LB-76 the standalone login uses the same room and form as the header dialog. */
import { Navigate, Link, useNavigate } from "react-router-dom";
import LightboxSurface from "../../components/lightbox/LightboxSurface";
import GlassPanel from "../../components/lightbox/GlassPanel";
import { initialTypeface } from "../../components/lightbox/typefaces";
import { LoginFormFlow, type LoginFormFlowClassNames } from "../../components/login";
import formSkin from "../../components/login/loginFormModalSkin.module.scss";
import styles from "./LoginPage.module.scss";
import { useLoginState } from "@/hooks";

const Login = () => {
  const navigate = useNavigate();
  const { isLoggedIn } = useLoginState();

  if (isLoggedIn) {
    return <Navigate to="/" replace />;
  }

  return (
    <LightboxSurface mode="static" typeface={initialTypeface()} onUnavailable={() => undefined}>
      <main className={styles.page}>
        <GlassPanel className={styles.card}>
          <h1 className={styles.title}>Log in</h1>
          <LoginFormFlow
            classNames={formSkin as LoginFormFlowClassNames}
            uponVerificationComplete={() => navigate("/", { replace: true })}
          />
          <p className={styles.footer}>Have an invite? <Link to="/register">Open it here →</Link></p>
        </GlassPanel>
      </main>
    </LightboxSurface>
  );
};

export default Login;
